// Harshada Bhavsar (21/07/2025)
// CServices/CSendCandidateService.js
import axios from "../../../axiosForm";
import Cookies from "js-cookie";

export const VerifyCandidate = async (payload) => {
  const formData = new FormData();

  // Append form fields
  formData.append("CandidateName", payload.CandidateName);
  formData.append("CandidateEmail", payload.CandidateEmail);
  formData.append("CandidatePhoneNo", payload.CandidatePhoneNo);
  formData.append("CandidatePAN", payload.CandidatePAN);
  formData.append("CandidateDOB", payload.CandidateDOB);
  formData.append("JobUID", payload.JobUID);
  formData.append("Token", payload.Token);

  return axios.post("/api/Consultant/VerifyCandidate", formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Send Candidate API
export const SendCandidate = async (payload) => {
  const formData = new FormData();

  formData.append("Token", payload.Token);
  formData.append("RequestID", payload.RequestID);
  formData.append("CurrentCTC", payload.CurrentCTC || "");
  formData.append("ExpectedCTC", payload.ExpectedCTC || "");
  formData.append("TotalExperience", payload.TotalExperience || "");
  formData.append("CurrentLocation", payload.CurrentLocation || "");
  formData.append("NoticePeriod", payload.NoticePeriod || "");
  formData.append("ReadytoRelocate", String(payload.ReadytoRelocate));
  formData.append("ReasonofLeaving", payload.ReasonofLeaving || "");
  formData.append("Remarks", payload.Remarks || "");

  if (payload.ResumeFile) {
    formData.append("ResumeFile", payload.ResumeFile);
  }

  return axios.post("/api/Consultant/SendCandidate", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
